var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6595DE8E-E4F2-475D-B751-B0A80DF9DD37") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    className: "icon-stroke",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sender-Portal---Notification-Settings-(Desktop)",
    transform: "translate(-879.000000, -326.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(286.000000, 229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delivery-Expired",
    transform: "translate(40.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-sms-24px",
    transform: "translate(554.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,0 L1.6,0 C0.72,0 0.008,0.72 0.008,1.6 L0,16 L3.2,12.8 L14.4,12.8 C15.28,12.8 16,12.08 16,11.2 L16,1.6 C16,0.72 15.28,0 14.4,0 Z M5.6,7.2 L4,7.2 L4,5.6 L5.6,5.6 L5.6,7.2 Z M8.8,7.2 L7.2,7.2 L7.2,5.6 L8.8,5.6 L8.8,7.2 Z M12,7.2 L10.4,7.2 L10.4,5.6 L12,5.6 L12,7.2 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.a7b4b06d5ec45c78670143f917714ca7.svg";
export { ForwardRef as ReactComponent };